import { useTheme } from 'styled-components'

export const useTransparentModalStyle = (zIndex: number) => {
  const theme = useTheme()

  return {
    overlay: {
      backgroundColor: theme.modal.overlay,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex
    },
    content: {
      position: 'static' as const,
      inset: 'auto',
      background: 'transparent',
      border: 'none',
      borderRadius: 0,
      padding: 0,
      maxWidth: 'none',
      overflow: 'visible'
    }
  }
}
